<div class="tile-padding-first tile-padding admin-page">

  <mat-tab-group [selectedIndex]="selectedIndex" (selectedIndexChange)="onTabChange($event)" animationDuration="0ms" data-test="system-controls-tabs">
    @for (tab of tabs; track tab.key) {
      <mat-tab [label]="tab.label">
        <!-- matTabContent: a tab's body (and its API calls) is only created when the tab is opened. -->
        <ng-template matTabContent>
        <div class="tw:pt-4" [attr.data-test]="'tab-' + tab.key">

        @if (tab.key === 'switches') {
          <p class="admin-lede">
            Runtime switches for background work and outbound communications. A change takes effect within about
            half a minute — no deploy, no restart. A process that is off produces silence rather than an error,
            so this screen is the only place it shows.
          </p>

          @if (loading) {
            <p>Loading…</p>
          }

          @if (!loading && disabled.length > 0) {
            <div class="tw:my-4 tw:p-3 tw:border tw:border-amber-500 tw:bg-amber-50 tw:text-amber-900 tw:rounded">
              <strong>{{disabled.length}} process{{disabled.length === 1 ? ' is' : 'es are'}} currently switched off.</strong>
              <ul class="tw:mt-2 tw:list-disc tw:ml-5">
                @for (process of disabled; track process.processKey) {
                  <li>
                    {{process.displayName}}
                    @if (process.updatedBy) {
                      <span> — turned off by <admin-email [value]="process.updatedBy" /> on {{process.updatedOn | date:'dd/MM/yyyy HH:mm'}}</span>
                    }
                  </li>
                }
              </ul>
            </div>
          }

          @if (!loading) {
            @for (group of groups; track group.category) {
              <h3 class="admin-h3">{{group.title}}</h3>
              @if (group.blurb) {
                <p class="admin-lede">{{group.blurb}}</p>
              }

              <div class="tw:overflow-x-auto">
                <table class="admin-table">
                  <thead>
                    <tr>
                      <th class="tw:text-left">Process</th>
                      <th class="tw:text-left tw:w-64">Last changed</th>
                      <th class="tw:text-left tw:w-24">On</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (process of group.processes; track process.processKey) {
                      <tr [class.tw:opacity-60]="!process.isEnabled">
                        <td>
                          <strong>{{process.displayName}}</strong>
                          @if (process.description) {
                            <div class="tw:text-sm tw:opacity-75">{{process.description}}</div>
                          }
                          <div class="tw:text-xs tw:opacity-50">{{process.processKey}}</div>
                        </td>
                        <td data-label="Last changed">
                          @if (process.updatedOn) {
                            <admin-email [value]="process.updatedBy || 'unknown'" /><br />
                            <span class="tw:text-sm tw:opacity-75">{{process.updatedOn | date:'dd/MM/yyyy HH:mm'}}</span>
                          } @else {
                            <span class="tw:text-sm tw:opacity-50">Never changed</span>
                          }
                        </td>
                        <td data-label="On">
                          <label class="field__toggle">
                            <input type="checkbox" role="switch" [checked]="process.isEnabled" [attr.aria-label]="process.displayName"
                              [disabled]="saving === process.processKey"
                              (change)="toggle(process, $event.target.checked)" />
                            <span class="field__toggle-track"></span>
                          </label>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          }

          @if (!loading && groups.length === 0) {
            <p>
              No system controls are configured. If this database has just been deployed, the catalogue is
              seeded by Seed.ServiceProcessFlags.sql — until it runs, every process is treated as enabled.
            </p>
          }
        }

        @if (tab.key === 'settings') {
          <ng-container *ngComponentOutlet="settingsEditor"></ng-container>
        }

        @if (tab.key === 'nudger') {
          <ng-container *ngComponentOutlet="nudgerEditor"></ng-container>
        }

        </div>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>

</div>